import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field } from 'formik';
import CustomSelect from '../../../home/collections/CustomSelect';
import { iconForField } from '../../../../common/custom/icon-library';
import { saveRuleUtil, showSaveButtonWorkflowUtil } from './workflow-util';
import { filterFieldsForForm } from 'drapcode-constant';

export default class WorkflowRuleForm extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    rule: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired,
    fieldOptions: PropTypes.array.isRequired,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
  };

  state = {
    currentValue: '',
    nextValue: [],
    role: '',
  };

  clearForm = () => {
    this.setState({
      currentValue: '',
      nextValue: [],
      role: '',
    });
  };

  customSelectHandleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  removeRule = () => {
    this.props.removeRule(this.props.rule.id);
  };

  saveRule = () => {
    const { rule } = this.props;
    const response = saveRuleUtil(this.props, this.state);
    const status = response.status;
    delete response['status'];
    if (status === 'ERROR') {
      this.setState(response);
    } else {
      this.props.saveWorkflowRule(rule.id, response);
    }
  };

  showSaveButton = () => {
    const showButton = showSaveButtonWorkflowUtil(this.props, this.state);
    if (showButton) {
      return (
        <button onClick={this.saveRule} type="button" className="btn btn-sm btn-theme-submit">
          <i className="wb webconnect-save-regular"></i>&nbsp;Save
        </button>
      );
    }
  };

  getRoleOption = () => {
    const { roles } = this.props;
    const roleOptions =
      roles.length > 0
        ? roles.map((role, key) => {
            return { value: role.uuid, label: role.name };
          })
        : [];
    return [...roleOptions];
  };

  getCollectionItemsOption = () => {
    const { collection, collectionItems, keyField } = this.props;
    const fields = filterFieldsForForm(collection.fields);

    const collectionField =
      fields.length > 0 && keyField
        ? fields.filter((fld) => fld && fld.fieldName === keyField.value)[0]
        : [];

    const itemOptions =
      Object.keys(collectionField.staticOptions).length > 0 && collectionField.staticOptions
        ? collectionField.staticOptions.map((item, key) => {
            return {
              value: key,
              label: item,
            };
          })
        : [];

    return [...itemOptions];
  };

  createRolesFieldSelector = (setFieldValue, setFieldTouched) => {
    let roles = this.getRoleOption();
    return this.props.keyField ? (
      <div className="form-group">
        <div className="input-group">
          <div
            className="input-group-prepend"
            title="Select Access Level on which you want to apply Workflow"
          >
            <span className="input-group-text">
              <i className={`wb ${iconForField('select')}`}></i>
              <span className="required d-none"> *</span>
            </span>
          </div>
          <CustomSelect
            name="role"
            isMulti={false}
            value={this.state.role}
            options={roles}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            onChangeValue={this.customSelectHandleChange}
            placeholder="Select Access Level (Optional)"
          />
          <ErrorMessage name="role">{(msg) => <p className="text-error">{msg}</p>}</ErrorMessage>
        </div>
      </div>
    ) : (
      ''
    );
  };

  createCurrentValueFieldSelector = (setFieldValue, setFieldTouched) => {
    const collectionItems = this.getCollectionItemsOption('keyField');

    return this.props.keyField ? (
      <div className="form-group">
        <div className="input-group">
          <div className="input-group-prepend" title="Select Workflow Current Value">
            <span className="input-group-text">
              <i className={`wb ${iconForField('select')}`}></i>
              <span className="required d-none"> *</span>
            </span>
          </div>
          <CustomSelect
            name="currentValue"
            isMulti={false}
            value={this.state.currentValue}
            options={collectionItems}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            onChangeValue={this.customSelectHandleChange}
            placeholder="Select Current Value (Optional)"
          />
          <ErrorMessage name="currentValue">
            {(msg) => <p className="text-error">{msg}</p>}
          </ErrorMessage>
        </div>
      </div>
    ) : (
      ''
    );
  };

  createNextValueFieldSelector = (setFieldValue, setFieldTouched) => {
    const collectionItems = this.getCollectionItemsOption('keyField');

    return this.props.keyField ? (
      <div className="form-group">
        <div className="input-group">
          <div className="input-group-prepend" title="Select Workflow Next Value(s)">
            <span className="input-group-text">
              <i className={`wb ${iconForField('select')}`}></i>
              <span className="required"> *</span>
            </span>
          </div>
          <CustomSelect
            name="nextValue"
            isMulti={true}
            value={this.state.nextValue}
            options={collectionItems}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            onChangeValue={this.customSelectHandleChange}
            placeholder="Select Next Value(s)"
          />
          <ErrorMessage name="nextValue">
            {(msg) => <p className="text-error">{msg}</p>}
          </ErrorMessage>
        </div>
      </div>
    ) : (
      ''
    );
  };

  createWorkflowProperties = (setFieldValue, setFieldTouched) => {
    return this.props.keyField ? (
      <Fragment>
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          {this.createRolesFieldSelector(setFieldValue, setFieldTouched)}
        </div>
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          {this.createCurrentValueFieldSelector(setFieldValue, setFieldTouched)}
        </div>
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          {this.createNextValueFieldSelector(setFieldValue, setFieldTouched)}
        </div>
      </Fragment>
    ) : (
      ''
    );
  };

  render() {
    const { setFieldValue, setFieldTouched, fieldOptions } = this.props;
    return (
      <Fragment>
        {this.createWorkflowProperties(setFieldValue, setFieldTouched)}
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
          {this.showSaveButton()}
          &nbsp;
          <button onClick={this.removeRule} type="button" className="btn btn-sm btn-theme-delete">
            <i className="wb webconnect-trash-regular"></i>&nbsp;Remove
          </button>
        </div>
      </Fragment>
    );
  }
}
